export default (state = {}, action) => {
    switch(action.type){
        case 'FETCH_INFO_DESCRIPTION':
                return  action.payload.indexOf('#') > -1 ? action.payload.substring(action.payload.indexOf('#')+1):"";

        default: return state;
    }
}
